import { memo, useContext } from "react";
import "../.././inner.css";
import "../../../../node_modules/bootstrap/dist/css/bootstrap.min.css";
import LazyLoad from "react-lazy-load";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Link } from "react-router-dom";
import { data1 } from "../../../App";

function Orthopedicser() {
  const setServiceseta = useContext(data1);
  const menu = [
    // 🟢 General Orthopedic Care
    {
      linkname: "Orthopaedic Clinic",
      to: "/service/orthopaedicClinic",
    },
    {
      linkname: "Orthopaedic Consultation",
      to: "/service/orthopaedicConsultation",
    },
    {
      linkname:
        "Evaluation and Diagnosis of Bone, Joint, Muscle and Ligament Problems",
      to: "/service/orthopaedicEvaluation",
    },
    {
      linkname: "Personalized Treatment Planning",
      to: "/service/treatmentPlanning",
    },

    // 🟢 Fracture & Trauma
    {
      linkname: "Bone Fracture Treatment Surgical And Conservative Treatment",
      to: "/service/boneFracture",
    },
    {
      linkname: "Fracture & Trauma Care",
      to: "/service/fractureTraumaCare",
    },
    {
      linkname: "Plaster Casting, Splinting and Follow-up Care",
      to: "/service/plasterCasting",
    },

    // 🟢 Sports & Ligament Injuries
    {
      linkname: "Sport Medicine",
      to: "/service/sportMedicine",
    },
    {
      linkname: "Sports Injury Management",
      to: "/service/sportsInjury",
    },
    {
      linkname: "Ligament Injuries (ACL, PCL, Meniscus)",
      to: "/service/ligamentInjuries",
    },
    {
      linkname: "Tendon Injuries and Muscle Strains",
      to: "/service/tendonMuscleInjuries",
    },
    {
      linkname: "Return-to-Sport Rehabilitation",
      to: "/service/returnToSport",
    },

    // 🟢 Arthroscopy & Minimally Invasive
    {
      linkname: "Arthroscopic Acl Andmenicus Repair Reconstruction",
      to: "/service/arthroscopicAcl",
    },
    {
      linkname: "Arthroscopic Shoulder Surgeries",
      to: "/service/arthroscopicShoulder",
    },
    {
      linkname: "Arthroscopy (Keyhole Surgery)",
      to: "/service/arthroscopy",
    },

    // 🟢 Joint & Arthritis Care
    {
      linkname: "Arthritis & Joint Pain Management",
      to: "/service/arthritisJointPain",
    },
    {
      linkname: "Joint Replacement Services",
      to: "/service/jointReplacement",
    },
    {
      linkname: "Knee And Hip Replacement Surgery Primary And Revision",
      to: "/service/kneeAndHip",
    },

    // 🟢 Spine Care
    {
      linkname: "Back Pain And Disc Related Diseases Treatment",
      to: "/service/backPain",
    },
    {
      linkname: "Back & Spine Care",
      to: "/service/backSpineCare",
    },

    // 🟢 Pediatric Orthopedics
    {
      linkname: "Paediatric Orthopaedics",
      to: "/service/paediatricOrthopaedics",
    },
    {
      linkname: "Congenital Deformities & Growth Related Issues",
      to: "/service/congenitalOrtho",
    },

    // 🟢 Pain & Regenerative Care
    {
      linkname: "Pain Management Procedures",
      to: "/service/painManagement",
    },
    {
      linkname: "Joint Injections",
      to: "/service/jointInjections",
    },
    {
      linkname: "PRP and Non-Surgical Pain Relief Options",
      to: "/service/prpTherapy",
    },

    // 🟢 Rehab & Recovery
    {
      linkname: "Rehabilitation & Physiotherapy Guidance",
      to: "/service/rehabilitation",
    },
    {
      linkname: "Post-Operative Rehabilitation Protocols",
      to: "/service/postOpRehab",
    },
    {
      linkname: "Strengthening and Mobility Exercises",
      to: "/service/mobilityExercises",
    },

    // 🟢 Wound Care
    {
      linkname: "Diabetic Wound Dressing And Management",
      to: "/service/diabeticWound",
    },
  ];

  const menutwo = [
    {
      linkname: "High intensity digital xray",
      to: "/service/highintensity",
    },
    {
      linkname: "Laboratory blood collection centre",
      to: "/service/laboratory",
    },
    {
      linkname: "Wound dressing",
      to: "/service/wounddressing",
    },
  ];

  return (
    <>
      <div className="orthselink">
        <LazyLoad className="serorthoimg">
          <img src="../photo/joint.png" alt="" />
        </LazyLoad>
        <div className="orthtrianglebox"></div>
        <div>
          {menu.map((elem) => {
            const { linkname, to } = elem;
            return (
              <>
                <div className="boxininfoma">
                  <Link
                    to={to}
                    onClick={() => {
                      setServiceseta(linkname);
                    }}
                    className="footinfo ortoliname"
                  >
                    <div className="arrowicon ortholicontrol">
                      <LazyLoadImage
                        className="arrowbar"
                        src="../photo/arrow-right.png"
                      />
                    </div>
                    <h6>{linkname}</h6>
                  </Link>
                </div>
              </>
            );
          })}
        </div>
      </div>
      {/* <div className="orthselink">
        <LazyLoad className="serorthoimg">
          <img src="../photo/fallopian-tubes.png" alt="" />
        </LazyLoad>
        <div className="orthtrianglebox"></div>
        <div>
          {menuone.map((elem) => {
            const { linkname, to } = elem;
            {
              return (
                <>
                  <div className="boxininfoma">
                    <Link
                      to={to}
                      onClick={() => {
                        setServiceseta(linkname);
                      }}
                      className="footinfo ortoliname"
                    >
                      <div className="arrowicon ortholicontrol">
                        <LazyLoadImage
                          className="arrowbar"
                          src="../photo/arrow-right.png"
                        />
                      </div>
                      <h6>{linkname}</h6>
                    </Link>
                  </div>
                </>
              );
            }
          })}
        </div>
      </div> */}
      <div className="orthselink">
        <LazyLoad className="serorthoimg">
          <img src="../photo/clinic.png" alt="" />
        </LazyLoad>
        <div className="orthtrianglebox"></div>
        <div>
          {menutwo.map((elem) => {
            const { linkname, to } = elem;
            return (
              <>
                <div className="boxininfoma">
                  <Link
                    to={to}
                    onClick={() => {
                      setServiceseta(linkname);
                    }}
                    className="footinfo ortoliname"
                  >
                    <div className="arrowicon ortholicontrol">
                      <LazyLoadImage
                        className="arrowbar"
                        src="../photo/arrow-right.png"
                      />
                    </div>
                    <h6>{linkname}</h6>
                  </Link>
                </div>
              </>
            );
          })}
        </div>
      </div>
    </>
  );
}
export default memo(Orthopedicser);
